import styled from 'styled-components';
import { LoadingAnimation as Loading } from 'components/Animations';

export const Container = styled.div`
  height: ${({ theme }) => theme._ui.chatPanel.heightMainContent};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LoadingAnimation = styled(Loading)`
  width: ${({ theme }) => theme.spacing['9Xl']};
`;
